<template lang="pug">
.m-card
  .m-card-header(:id="'heading-tg-' + id" :data-bs-target="'#collapse-tg-' + id" :aria-controls="'collapse-tg-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_TG", 1) }}
  .m-card-body.collapse.show(:id="'collapse-tg-' + id" :aria-labelledby="'heading-tg-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T
          .odds-group 
            template(v-for="item in tgo")
              template(v-if="moreItems['tgo'][item] && moreItems['tgo'][item][5] !=  null && moreItems['tgo'][item][5] != 0 && moreItems['tgo'][item][5] != ''")
                OddsItem.col-more-scroll(:odds="moreItems['tgo'][item] " idx=5 :typ="oddsType" dataType="3" :label="item == '7Up' ? '7+' : item")
              template(v-else)
                OddsDisabled.col-more-scroll            
        .odds-wrapper(v-if="$helpers.objSize(moreItems['tgho']) > 0 && (mode == 0 || mode == 2)")
          .m-label-wrap
            .m-label H.T
          .odds-group
            template(v-for="item in tgho")
              template(v-if="moreItems['tgho'][item] && moreItems['tgho'][item][5] !=  null && moreItems['tgho'][item][5] != 0 && moreItems['tgho'][item][5] != ''")
                OddsItem.col-more-scroll(:odds="moreItems['tgho'][item] " idx=5 :typ="oddsType" dataType="3" :label="item == '4Up' ? '4+' : item")
              template(v-else)
                OddsDisabled.col-more-scroll              
//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-tg-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-tg-' + id"
//-     :aria-controls="'collapse-tg-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_TG", 1) }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-tg-' + id"
//-     :id="'collapse-tg-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 0-1
//-               template(v-if="moreItems['tgo']['0-1'] && moreItems['tgo']['0-1'][5] != 0 && moreItems['tgo']['0-1'][5] != ''")
//-                 OddsItem(:odds="moreItems['tgo']['0-1']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 2-3
//-               template(v-if="moreItems['tgo']['2-3'] && moreItems['tgo']['2-3'][5] != 0 && moreItems['tgo']['2-3'][5] != ''")
//-                 OddsItem(:odds="moreItems['tgo']['2-3']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 4-6
//-               template(v-if="moreItems['tgo']['4-6'] && moreItems['tgo']['4-6'][5] != 0 && moreItems['tgo']['4-6'][5] != ''")
//-                 OddsItem(:odds="moreItems['tgo']['4-6']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 7+
//-               template(v-if="moreItems['tgo']['7Up'] && moreItems['tgo']['7Up'][5] != 0 && moreItems['tgo']['7Up'][5] != ''")
//-                 OddsItem(:odds="moreItems['tgo']['7Up']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-         .normal(v-if="$helpers.objSize(moreItems['tgho']) > 0 && (mode == 0 || mode == 2)")
//-           .normal-title {{ $t("ui.half_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 0-1
//-               template(v-if="moreItems['tgho']['0-1'] && moreItems['tgho']['0-1'][5] != 0 && moreItems['tgho']['0-1'][5] != ''")
//-                 OddsItem(:odds="moreItems['tgho']['0-1']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 2-3
//-               template(v-if="moreItems['tgho']['2-3'] && moreItems['tgho']['2-3'][5] != 0 && moreItems['tgho']['2-3'][5] != ''")
//-                 OddsItem(:odds="moreItems['tgho']['2-3']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 4+
//-               template(v-if="moreItems['tgho']['4Up'] && moreItems['tgho']['4Up'][5] != 0 && moreItems['tgho']['4Up'][5] != ''")
//-                 OddsItem(:odds="moreItems['tgho']['4Up']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      tgo: ["0-1", "2-3", "4-6", "7Up"],
      tgho: ["0-1", "2-3", "4Up"]
    }
  }
}
</script>
